import { Pipe, PipeTransform } from '@angular/core';
import {
  DOCUMENT_STATUS_DISPLAY_LABELS,
  DocumentStatus,
} from 'src/app/document-user/enums/document-status.enum';

@Pipe({
  name: 'documentStatusMap',
  pure: true,
  standalone: true,
})
export class DocumentStatusMapPipe implements PipeTransform {
  transform(documentStatus: DocumentStatus): string {
    return DOCUMENT_STATUS_DISPLAY_LABELS[documentStatus];
  }
}
